// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Fallback (usado se ng serve sem --configuration)
// export const environment = {
//   production: false,
//   baseUrl: 'https://homolog-api.portaldoalunocurso.com.br',
//   urlTef: 'http://localhost:5000/pagamento'
// };

export const environment = {
  production: false,
  baseUrl: 'http://localhost:8081/',
  urlTef: 'http://localhost:5000/pagamento',
  urlWebhookApi: 'http://localhost:8081',
  envName: 'DEV'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

